export default __webpack_public_path__ + "static/media/EditParLevelsOrange.46a07cc9.png";